import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    eventResults: [],
    eventResult: {} 
  },
  mutations: {
    index(state, payload) {
      state.eventResults = payload
    },
    show(state,payload) {
      state.eventResult = payload
    }
  },
  actions: {
    index ({commit}) {
      axios.get(`${ENV.API_URL}/api/event_results`).then((res) => {
        commit('index', res.data)
      })
    },
    show({commit}, payload) {
      axios.get(`${ENV.API_URL}/api/event_results/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      axios.post(`${ENV.API_URL}/api/event_results`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    uptade({commit}, payload) {
      axios.put(`${ENV.API_URL}/api/event_results/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    eventResults: state => {
      return state.eventResults
    },
    eventResult: state => {
      return state.eventResult
    }
  },
  modules: {
  }
}
